import { LinkButton } from '@cian/ui-kit/button';
import { FC } from 'react';

import { QUALITY_OF_SERVICE_URL } from 'shared/containers/Superhost/const';

import heroImg from '../assets/hero.png';
import style from './Hero.css';
import { useDeviceType } from '@cian/ui-kit';

export const Hero: FC = () => {
  const isMobile = useDeviceType() === 'phone';
  const cardStyle = { '--card-bg': `url(${heroImg})` } as React.CSSProperties;

  return (
    <section className={style['hero']}>
      <div className={style['inner']} style={cardStyle}>
        <div className={style['card']}>
          <div className={style['text-container']}>
            <h1 className={style['title']}>Суперхозяин</h1>
            <p className={style['subtitle']}>Программа лояльности для тех, кто сдаёт жильё посуточно</p>
          </div>
          <div className={style['cta-button']}>
            <LinkButton theme="fill_white_primary" size="L" href={QUALITY_OF_SERVICE_URL} fullWidth={isMobile}>
              Проверить свой уровень
            </LinkButton>
          </div>
        </div>
      </div>
    </section>
  );
};
